import React, {FC} from 'react';

import {DataEventActionsEnum} from '../../../../../libs/shared/core/src/models/tracking/dataEventActions';
import {MacrosDataEventObject} from '../../../../../libs/shared/core/src/models/tracking/objectNames/macrosDataEventObject';
import {useDataEventTracking} from '../../../../../libs/shared/core/src/services/tracking/dataEventTrackingContext';
import {MacroModel} from '../../../../models/api/macroModel';
import {MacroTooltipCoordinator} from './macroTooltipCoordinator';
import {InheritableTriggerButtonProps, TriggerButton} from './triggerButton';

interface MacroButtonProps extends InheritableTriggerButtonProps {
  macro: MacroModel;
  onRunMacro: () => void;
}

export const MacroButton: FC<MacroButtonProps> = ({macro, renderDropdown, onRunMacro}) => {
  const {trackDataEvent} = useDataEventTracking();

  const runMacro = () => {
    trackDataEvent(DataEventActionsEnum.CLICK, MacrosDataEventObject.SUGGESTED_MACRO, {
      macro_id: macro.id,
    });
    onRunMacro();
  };

  return (
    <TriggerButton
      interactionId="macro-trigger-button"
      interactionData={{macro_id: macro.id}}
      onDropdownToggle={(isOpen) => {
        if (!isOpen) {
          return;
        }
        trackDataEvent(DataEventActionsEnum.EXPAND, MacrosDataEventObject.MACRO_LIST);
      }}
      title={macro.name}
      onSelect={runMacro}
      renderDropdown={renderDropdown}
      renderTooltip={(children) => (
        <MacroTooltipCoordinator macro={macro} placement="bottom" customMargin="4px">
          {children}
        </MacroTooltipCoordinator>
      )}
    />
  );
};
